// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"92cfeed4","106":"e8bcd3c1","241":"011830b6","296":"38334099","364":"224b50ad","411":"8bf10d75","453":"d855a71b","466":"14f02206","474":"efe14015","494":"39cb6106","519":"ff5cffd2","541":"3a831fd8","665":"868d0505","703":"ecc88f18"}[chunkId] + ".chunk.js";
};